import { useState, useRef, useEffect } from "react";
import "./styles/challenge-hosting.css";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import BackgroundPaths from "../../../ui/molecules/background-paths/BackgroundPaths";
import Button from "../../../ui/atoms/buttons/Button";
import ASSETS from "../../../app/config/assets";
import { BsCheck2Circle } from "react-icons/bs";
import { SlClose } from "react-icons/sl";
import StatusComponent from "../../../ui/atoms/status/StatusComponent";
import { QRCodeCanvas } from "qrcode.react";
import { FaUsers } from "react-icons/fa";
import { AiOutlineFullscreen, AiOutlineFullscreenExit } from "react-icons/ai";
//
import ChallengeDescription from "../components/challenge-hosting/challenge-description/ChallengeDescription";
import ChallengeReports from "../components/challenge-hosting/challenge-reports/ChallengeReports";
import JoiningRequests from "../components/challenge-hosting/joining-requests/JoiningRequests";
//
import Swal from "sweetalert2";
import moment from "moment";
import { useFullscreen } from "../../../app/providers/useFullscreen";
import {
  onGetChallengeDetailsByInscriptionIdAndChallengeId,
  onProcessChallengeStatus,
  onHostingGetChallengeCurrentQuestion,
  onHostingLaunchQuestion,
} from "../services/challenge";
import { socketIo } from "../../../core/socket/socket-client";
import useAxiosPrivate from "../../../app/providers/context-provider/useAxiosPrivate";

const ChallengeHosting = () => {
  const { challenge_id } = useParams();

  const axiosPrivate = useAxiosPrivate();

  const connectedUser = useSelector(
    (state) => state.setInitConf.initConnectedUser.connectedUserData,
  );
  const _inscription_id = connectedUser?.userInfo?.inscription;

  const [isDetailsChallenge, setIsDetailsChallenge] = useState(false);
  const [isReportChallenge, setIsReportChallenge] = useState(false);
  const [isRequestChallenge, setIsRequestChallenge] = useState(false);

  const [challengeDetailsData, setChallengeDetailsData] = useState({});

  const [questionIndex, setQuestionIndex] = useState(0);
  const [questionIndexData, setQuestionIndexData] = useState({});
  const [isCorrection, setIsCorrection] = useState(false);

  const wrapperRef = useRef(null);
  const { isFullscreen, enter, exit } = useFullscreen();

  const toggleFullscreen = () => {
    if (isFullscreen) exit();
    else enter(wrapperRef.current);
  };

  useEffect(() => {
    _onGetChallengeDetails();
  }, []);

  useEffect(() => {
    socketIo.emit("authenticate", { inscription_id: _inscription_id });

    const onHandleChallengeDetails = (data) => {
      if (data?.status) _onGetChallengeDetails();
    };

    socketIo.on("on_challenge_current_status", onHandleChallengeDetails);
    socketIo.on(
      "on_request_joining_challenge_process_state",
      onHandleChallengeDetails,
    );

    return () => {
      socketIo.off("on_challenge_current_status", onHandleChallengeDetails);
      socketIo.off(
        "on_request_joining_challenge_process_state",
        onHandleChallengeDetails,
      );
    };
  }, [challengeDetailsData]);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;

    const localData = {
      challenge_id: challenge_id,
      question_index: questionIndex,
    };

    onHostingGetChallengeCurrentQuestion(axiosPrivate, localData, signal)
      .then((response) => {
        // console.log({ "HOSTING STATE": response });
        const _data = response?.data?.result;
        //
        setQuestionIndexData(_data);
        setIsCorrection(false);
      })
      .catch((error) => {
        if (!error?.response) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No server response",
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "Warning",
            text: error?.response?.data?.message,
          });
        }
      });

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [questionIndex]);

  const _onGetChallengeDetails = () => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;

    const localData = {
      inscription_id: _inscription_id,
      challenge_id: challenge_id,
    };

    onGetChallengeDetailsByInscriptionIdAndChallengeId(localData, signal)
      .then((response) => {
        const _data = response?.data?.result;
        //
        setChallengeDetailsData(_data);
      })
      .catch((error) => {
        if (!error?.response) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No server response",
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "Warning",
            text: error?.response?.data?.message,
          });
        }
      });

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  const _onProcessChallengeStatus = (status) => {
    const local_data = {
      inscription_id: _inscription_id,
      challenge_id: challengeDetailsData?.challenge?.id,
      challenge_code: challengeDetailsData?.challenge?.code,
      current_status: status,
      request_dates: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
    onProcessChallengeStatus(local_data)
      .then((response) => {
        console.log({ updatedChallengeStatus: response });
        const _data = response?.data?.result;
      })
      .catch((error) => {
        if (!error?.response) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No server response",
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "Warning",
            text: error?.response?.data?.message,
          });
        }
      });
  };

  const _onHostingLaunchQuestion = () => {
    const local_data = {
      question_id: questionIndexData?.current_question?.id,
      is_launched: !questionIndexData?.current_question?.is_launched,
      request_dates: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
    onHostingLaunchQuestion(local_data)
      .then((response) => {
        const _data = response?.data?.result;
      })
      .catch((error) => {
        if (!error?.response) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No server response",
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "Warning",
            text: error?.response?.data?.message,
          });
        }
      });
  };

  return (
    <div className="challenge-hosting">
      <div className="challenge-hosting-banner">
        <BackgroundPaths />
      </div>
      <div className="challenge-hosting-wrapper">
        <div className="c-h-w-head d-flex justify-space-between align-center p-lg">
          <div className="w-fit-content c-code-info">
            <span>Grabs the challenge's Code below or Scan the QRCode :</span>
            <h1>{challengeDetailsData?.challenge?.code || "---"}</h1>
            <div className="w-fit-content d-flex gap-md">
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"Challenge's Details"}
                action={() => setIsDetailsChallenge(true)}
              />
              <Button
                type={"button"}
                preferedStyle={"normal"}
                title={" Challenge's Report"}
                action={() => setIsReportChallenge(true)}
              />
              <div className="w-fit-content pulse-requests">
                <Button
                  type={"button"}
                  preferedStyle={"default"}
                  title={"See Requests"}
                  action={() => setIsRequestChallenge(true)}
                />
              </div>
            </div>
          </div>
          <div className="w-fit-content c-qr-code-info">
            <div className="qr-inner">
              <QRCodeCanvas
                value={challengeDetailsData?.challenge?.code}
                className="qr-code"
                size={236}
              />
            </div>
            <div className="qr-outer fade-in"></div>
          </div>
          <div className="w-fit-content c-joining-info">
            <p>At least, one user have to join before starting!</p>
            <FaUsers className="icon" />
            <h2>Total Players joined :</h2>
            <h1>
              {challengeDetailsData?.total_joined} /{" "}
              {challengeDetailsData?.challenge?.total_teams *
                challengeDetailsData?.challenge?.numbers_of_players_per_team}
            </h1>
            <div className="w-fit-content d-flex gap-xs">
              {challengeDetailsData?.challenge?.current_status ===
                "hosting" && (
                <>
                  <Button
                    type={"button"}
                    preferedStyle={"default"}
                    title={"Cancel Challenge"}
                    action={() => _onProcessChallengeStatus("cancelled")}
                  />
                  <Button
                    type={"button"}
                    preferedStyle={"default"}
                    title={"Stop Challenge"}
                    action={() => _onProcessChallengeStatus("stoped")}
                  />
                </>
              )}
              {challengeDetailsData?.challenge?.current_status ===
                "pending" && (
                <Button
                  type={"button"}
                  preferedStyle={"normal"}
                  title={"Start Challenge"}
                  action={() => _onProcessChallengeStatus("hosting")}
                />
              )}
            </div>
          </div>
        </div>
        <div
          className={isFullscreen ? "c-h-w-body full-screen" : "c-h-w-body"}
          ref={wrapperRef}
        >
          <div className="c-h-w-body-leaderbord"></div>
          <div className="c-h-w-body-question">
            <div className="b-q-options">
              <div className="op-tile">
                <div className="pagination">
                  <div className="p-wrapper">
                    <button
                      className={
                        questionIndex === 0
                          ? "button is-inactive"
                          : "button is-active"
                      }
                      onClick={() =>
                        setQuestionIndex((prev) => (prev > 0 ? prev - 1 : 0))
                      }
                      disabled={questionIndex === 0}
                    >
                      Previous Question
                    </button>
                    <span>
                      Question {questionIndex + 1} of{" "}
                      {challengeDetailsData?.total_questions} Questions.
                    </span>
                    <button
                      className={
                        questionIndex ===
                        challengeDetailsData?.total_questions - 1
                          ? "button is-inactive"
                          : "button is-active"
                      }
                      onClick={() =>
                        setQuestionIndex((prev) =>
                          prev < challengeDetailsData?.total_questions
                            ? prev + 1
                            : prev,
                        )
                      }
                      disabled={
                        questionIndex ===
                        challengeDetailsData?.total_questions - 1
                      }
                    >
                      Next Question
                    </button>
                  </div>
                </div>
              </div>
              <div className="op-tile">
                {questionIndexData?.current_question?.is_launched ? (
                  <StatusComponent
                    type={"success"}
                    title={"Question Launched"}
                  />
                ) : (
                  <Button
                    type={"button"}
                    preferedStyle={"default"}
                    title={"Launch"}
                    action={() => _onHostingLaunchQuestion()}
                  />
                )}
                <Button
                  type={"button"}
                  preferedStyle={"default"}
                  title={isCorrection ? "Hide correction" : "Correction"}
                  action={() => setIsCorrection(!isCorrection)}
                />
              </div>
              <span className="fullscreen-btn" onClick={toggleFullscreen}>
                {isFullscreen ? (
                  <AiOutlineFullscreenExit className="icon" />
                ) : (
                  <AiOutlineFullscreen className="icon" />
                )}
              </span>
            </div>
            <div className="b-q-content">
              <div className="b-q-c-description">
                <img
                  src={
                    isFullscreen
                      ? ASSETS?.icon_question_gif
                      : ASSETS?.icon_question_png
                  }
                  alt="question illustartion icon"
                />
                <p
                  dangerouslySetInnerHTML={{
                    __html: questionIndexData?.current_question?.description,
                  }}
                />
              </div>
              {isCorrection && (
                <div className="w-full fade-in">
                  <div className="b-q-c-description">
                    <img
                      src={
                        isFullscreen
                          ? ASSETS?.icon_brain_light_gif
                          : ASSETS?.icon_brain_light_png
                      }
                      alt="question illustartion icon"
                    />
                    <p
                      dangerouslySetInnerHTML={{
                        __html:
                          questionIndexData?.current_question?.explanations,
                      }}
                    />
                  </div>
                  <div className="answers-wrapper">
                    {questionIndexData?.current_question?.answers?.map(
                      (answer, idx) => {
                        return (
                          <div
                            className={
                              answer?.is_correct
                                ? "answer-item is-good"
                                : "answer-item is-wrong"
                            }
                            key={idx}
                          >
                            {answer?.is_correct ? (
                              <span>
                                <BsCheck2Circle className="icon" />
                              </span>
                            ) : (
                              <span>
                                <SlClose className="icon" />
                              </span>
                            )}
                            <p
                              dangerouslySetInnerHTML={{
                                __html: answer?.answer,
                              }}
                            />
                          </div>
                        );
                      },
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {isDetailsChallenge && (
        <div className="w-40 challenge-hosting-details fade-in">
          <div className="w-full c-host-det-head d-flex justify-space-between">
            <h1>Challenge Details</h1>
            <Button
              type={"button"}
              preferedStyle={"default"}
              title={"Close"}
              action={() => setIsDetailsChallenge(false)}
            />
          </div>
          <div className="w-full c-host-det-body">
            <ChallengeDescription data={challengeDetailsData?.challenge} />
          </div>
        </div>
      )}
      {isReportChallenge && (
        <div className="w-full challenge-hosting-details fade-in">
          <div className="c-host-det-head d-flex justify-space-between">
            <h1>Challenge Reports</h1>
            <Button
              type={"button"}
              preferedStyle={"default"}
              title={"Close"}
              action={() => setIsReportChallenge(false)}
            />
          </div>
          <div className="c-host-det-body">
            <ChallengeReports challenge_id={challenge_id} />
          </div>
        </div>
      )}
      {isRequestChallenge && (
        <div className="w-70 challenge-hosting-details fade-in">
          <div className="c-host-det-head d-flex justify-space-between">
            <h1>Challenge Players requests Handling</h1>
            <Button
              type={"button"}
              preferedStyle={"default"}
              title={"Close"}
              action={() => setIsRequestChallenge(false)}
            />
          </div>
          <div className="c-host-det-body">
            <JoiningRequests
              challenge_id={challenge_id}
              inscription_id={_inscription_id}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ChallengeHosting;
